// Data transformation functions
export function mapCategoryItem(item) {
  if (item && typeof item === "object") {
    return {
      label: item.category_name || item.title || item.name || "Category",
      isFlash:
        item.is_flash_cards === "Y" || item.isFlash === "Y" || item.flash === true,
      isQuestions:
        item.is_questions === "Y" || item.isQuestions === "Y" || item.questions === true,
      videoUrl: item.videoUrl || item.video_url || "",
    };
  }
  return { label: String(item), isFlash: true, isQuestions: true, videoUrl: "" };
}

export function normalizeQuestion(q) {
  return {
    ...q,
    question: q.question || q.Question || "",
    answer: q.answer || q.Answer || "",
    explanation: q.explanation || q.Explanation || "",
    options: q.options || q.Options || [],
  };
}
